import { render, staticRenderFns } from "./LearningGoalQuizList.vue?vue&type=template&id=64579c70&"
import script from "./LearningGoalQuizList.vue?vue&type=script&lang=js&"
export * from "./LearningGoalQuizList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports